export const ANIMATED_ANIMATIONS_EMPTY = Object.freeze({});
